module.exports = __webpack_public_path__ + "img/sponsorW02.6fa0553b.png";